var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-right_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M37.902 13.014 36.514 14.4l15.585 15.586H3.513v4.026h48.586L36.514 49.599l2.837 2.836L59.785 32 49.598 21.813C43.996 16.21 39.384 11.626 39.35 11.626s-.685.624-1.449 1.388",
    clipRule: "evenodd"
  })));
};
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM3LjkwMTUgMTMuMDEzNkwzNi41MTM5IDE0LjQwMTJMNTIuMDk5MyAyOS45ODdIMy41MTI5NFYzNC4wMTNINTIuMDk5M0wzNi41MTM1IDQ5LjU5OUwzOS4zNTEgNTIuNDM0Nkw1OS43ODUzIDMyTDQ5LjU5ODQgMjEuODEzQzQzLjk5NTcgMTYuMjEwMSAzOS4zODQgMTEuNjI2IDM5LjM1MDMgMTEuNjI2QzM5LjMxNjYgMTEuNjI2IDM4LjY2NDcgMTIuMjUwNCAzNy45MDE1IDEzLjAxMzZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";